import { story } from '@w/ui/storybook'
import { useState } from 'react'

function StackDisplay({ stack }: { stack: string }) {
  return (
    <pre
      style={{
        background: '#1a1a2e',
        color: '#e0e0e0',
        padding: 16,
        borderRadius: 8,
        fontSize: 12,
        lineHeight: 1.5,
        overflow: 'auto',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-all',
        userSelect: 'all',
        maxHeight: 400,
      }}
    >
      {stack}
    </pre>
  )
}

// --- SyncRenderError ---

function ThrowInRender(): never {
  throw new TypeError('sync render kaboom')
}

export function SyncRenderError() {
  const [show, setShow] = useState(false)
  return (
    <div>
      <button
        type="button"
        onClick={() => {
          setShow(true)
        }}
      >
        Trigger sync render error
      </button>
      {show && <ThrowInRender />}
    </div>
  )
}

// --- NestedError ---

function levelC(): never {
  throw new RangeError('deep nesting error')
}
function levelB() {
  return levelC()
}
function levelA() {
  return levelB()
}

export function NestedError() {
  const [show, setShow] = useState(false)
  if (show) levelA()
  return (
    <button
      type="button"
      onClick={() => {
        setShow(true)
      }}
    >
      Trigger nested error (A→B→C→throw)
    </button>
  )
}

// --- EventHandlerError ---

function handleBtnClick(): never {
  throw new Error('event handler error')
}

export function EventHandlerError() {
  return (
    <button type="button" onClick={handleBtnClick}>
      Trigger event handler error
    </button>
  )
}

// --- AsyncError ---

async function fetchData(): Promise<never> {
  await Promise.resolve()
  throw new Error('async fetch failed')
}

export function AsyncError() {
  return (
    <button
      type="button"
      onClick={() => {
        void fetchData()
      }}
    >
      Trigger async error
    </button>
  )
}

// --- StackCapture ---

function innerCapture() {
  return new Error('captured stack')
}
function outerCapture() {
  return innerCapture()
}

export function StackCapture() {
  const [stack, setStack] = useState<string | null>(null)

  return (
    <div>
      <button
        type="button"
        onClick={() => {
          const err = outerCapture()
          setStack(err.stack ?? 'no stack')
        }}
      >
        Capture stack (no throw)
      </button>
      {stack && <StackDisplay stack={stack} />}
    </div>
  )
}

export default {
  SyncRenderError: story(SyncRenderError),
  NestedError: story(NestedError),
  EventHandlerError: story(EventHandlerError),
  AsyncError: story(AsyncError),
  StackCapture: story(StackCapture),
}
